<template>
  <!-- <div
    :class="[
      'form-item',
      labelPosition ? 'form-item-' + labelPosition : '',
      nolabel ? 'nolabel' : ''
    ]"
    :id="curId"
  > -->
  <el-col
    :xs="itemWidth[0]"
    :sm="itemWidth[1]"
    :md="itemWidth[2]"
    :lg="itemWidth[2]"
    :xl="itemWidth[2]"
  >
    <div
      :id="curId"
      :class="[
        'form-item',
        labelPosition ? 'form-item-' + labelPosition : '',
        nolabel ? 'nolabel' : '',
        {
          'form-outline': outline,
        },
      ]"
    >
      <el-form-item
        :prop="prop"
        :rules="rules"
        :label-width="initWidth"
        :required="required"
        :validate-status="validateStatus"
        size="mini"
      >
        <template v-if="!nolabel" slot="label">
          <el-tooltip
            effect="dark"
            :content="label"
            placement="top-start"
            :disabled="disabled"
            :tabindex="-1"
          >
            <span>{{ label }}</span>
          </el-tooltip>
          <p v-if="labelPosition === 'top'" class="label-replace">{{label}}</p>
        </template>
        <slot />

        <el-tooltip
          effect="light"
          :tabindex="-1"
          :content="curErrMsg"
          placement="top"
        >
          <cnd-icon
            name="cnd-exclamation"
            style="display: none"
            class="form-item-error"
          />
        </el-tooltip>
      </el-form-item>
    </div>
  </el-col>
  <!-- </div> -->
</template>

<script>
import { Tooltip, FormItem, Col } from 'element-ui'
export default {
  name: 'FormItem',
  components: {
    ElTooltip: Tooltip,
    ElFormItem: FormItem,
    ElCol: Col
  },
  provide() {
    return {
      cubeFormItem: this
    }
  },
  props: {
    // 标题
    label: {
      type: String,
      default: ''
    },
    // 标题宽度
    labelWidth: {
      type: [String, Number],
      default: ''
    },
    // 标题位置 right/top
    labelPosition: {
      type: String,
      default: 'top'
    },
    // input 绑定值
    prop: {
      type: String,
      default: ''
    },
    errorMsg: {
      type: String,
      default: ''
    },
    validateStatus: {
      type: String,
      default: ''
    },
    // item 占位栅格
    customWidth: {
      type: [Number, Array],
      default: 0
    },
    // 取消标题
    nolabel: {
      type: Boolean,
      default: false
    },
    // input 输入规则
    rules: {
      type: [Array, Object],
      default: () => {
        return null
      }
    },
    // 标题提示icon
    tips: {
      type: String,
      default: ''
    },
    outline: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      disabled: true
    }
  },
  computed: {
    initWidth() {
      if (Number.isFinite(Number(this.labelWidth))) {
        return `${this.labelWidth * 1 + 50}px`
      }
      return this.labelWidth
    },
    curErrMsg() {
      return this.errorMsg || ''
    },
    curId() {
      const timestamp = new Date().getTime()
      return this.label + timestamp
    },
    itemWidth() {
      let tempArr = [8, 6, 4]
      // let tempArr = [15, 10, 5]
      // let tempArr = [24, 12, 6]

      if (Array.isArray(this.customWidth)) {
        return this.customWidth
      }

      if (this.customWidth !== 0) {
        const colSpan = this.customWidth / 4
        if (colSpan === 2) {
          tempArr = [16, 12, 8]
        } else {
          for (let i = 0; i < tempArr.length; i++) {
            tempArr[i] = this.customWidth
          }
        }
      }
      return tempArr
    }
  },
  async mounted() {
    this.$nextTick(() => {
      this.showToolTip()
    })
    const resizeObserver = new ResizeObserver((resizeObserverEntry) => {
      resizeObserverEntry.forEach(() => {
        this.showToolTip()
      })
    })
    resizeObserver.observe(this.$el)
  },
  methods: {
    showToolTip() {
      this.$nextTick(() => {
        const label1 = this.$el.querySelector('.el-tooltip')

        this.disabled = label1.clientWidth >= label1.scrollWidth
      })
    }
  }
}
</script>
<style lang="scss" scopoed>
@import '../../../../lib/styles/components/FormItem.scss';
</style>
